/** True when the browser runs on a phone or tablet (not desktop). */
export function isMobileDevice(): boolean {
  return /android|iphone|ipad|ipod/i.test(navigator.userAgent);
}
